import { ReservedNodeType } from '@morph-mapper/types';

export const ROOT_KEY = 'root';

export const iteratorKeys = [ReservedNodeType.Iterator].map((e) =>
  e.valueOf()
);
